<template lang="pug">
  div
    v-toolbar(light)
      v-toolbar-title {{title}} 
      v-text-field(v-model="it")
      v-btn(icon @click="addItem")
        v-icon add_circle
    v-card
      v-list
        v-list-tile(v-for="item in contents")
          v-list-tile-content
            v-list-tile-title( v-html="item")
          v-list-tile-action(@click="deleteItem(item)")
            v-icon delete
</template>
<script>
export default {
  name:'ListBuilder',
  props:['title', 'items', 'listHeaderText', 'inputLabel'],
  data:()=>({
    it:'',
    contents: []
  }),
  methods:{
    addItem(){
      if (this.it.trim() !== ''){
        this.contents.push(this.it+"")
        this.it = ""
        this.$emit('contentChanged', this.contents)
      }
      
    },
    deleteItem(i){
      this.contents = this.contents.filter((el)=>{return el !== i})
      this.$emit('contentChanged', this.contents)
    }
  }

}
</script>
